import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { FoilButton } from "@/components/ui/foil-button";

interface EmailActionFieldProps {
  id: string;
  label: string;
  placeholder: string;
  value: string;
  action: ReactNode;
  disabled?: boolean;
  error?: boolean;
  animateError?: boolean;
  className?: string;
  onValueChange: (value: string) => void;
  onSubmit: () => void;
}

export function EmailActionField({
  id,
  label,
  placeholder,
  value,
  action,
  disabled = false,
  error = false,
  animateError = false,
  className,
  onValueChange,
  onSubmit,
}: EmailActionFieldProps) {
  return (
    <form
      className={cn(
        "grid grid-cols-1 gap-1.5 rounded-[24px] border bg-black/28 p-1.5 shadow-[inset_0_1px_0_rgba(255,255,255,0.07),0_20px_56px_rgba(0,0,0,0.24)] backdrop-blur-xl transition-colors min-[520px]:grid-cols-[minmax(0,0.72fr)_minmax(12rem,1.28fr)]",
        error
          ? cn("border-rose-200/34", animateError && "animate-shake")
          : "border-white/10 focus-within:border-cyan-100/24",
        className,
      )}
      onSubmit={(event) => {
        event.preventDefault();
        onSubmit();
      }}
    >
      <div className="min-w-0">
        <label className="sr-only" htmlFor={id}>
          {label}
        </label>
        <input
          className="h-14 w-full min-w-0 bg-transparent px-4 text-sm text-white outline-none placeholder:text-white/32"
          id={id}
          placeholder={placeholder}
          type="email"
          value={value}
          onChange={(event) => onValueChange(event.target.value)}
        />
      </div>

      <div className="min-w-0 rounded-[18px] bg-[linear-gradient(100deg,rgba(143,232,244,0.7),rgba(174,188,248,0.3)_52%,rgba(191,116,242,0.68))] p-px shadow-[0_10px_34px_rgba(150,190,255,0.1)]">
        <FoilButton
          className="h-14 w-full min-w-0 rounded-[17px] px-8 text-sm font-medium"
          disabled={disabled}
          tone="aurora"
          type="submit"
        >
          {action}
        </FoilButton>
      </div>
    </form>
  );
}
